/* Isolated native dialog enhancement. No requests, cart events, or tracking. */
(() => {
  if (customElements.get('hn-info-modal')) return;
  const locks = new Set();
  let savedOverflow = '';
  let savedPriority = '';
  function lock(owner) {
    if (!locks.size) {
      savedOverflow = document.documentElement.style.getPropertyValue('overflow');
      savedPriority = document.documentElement.style.getPropertyPriority('overflow');
      document.documentElement.style.setProperty('overflow', 'hidden');
    }
    locks.add(owner);
  }
  function unlock(owner) {
    if (!locks.delete(owner) || locks.size) return;
    if (savedOverflow) document.documentElement.style.setProperty('overflow', savedOverflow, savedPriority);
    else document.documentElement.style.removeProperty('overflow');
  }
  customElements.define('hn-info-modal', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.trigger = this.querySelector('[data-hn-open]');
      this.dialog = this.querySelector('dialog.hn-modal');
      if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.trigger.addEventListener('click', event => {
        event.preventDefault();
        if (this.dialog.open) return;
        this.dialog.showModal();
        lock(this);
        this.trigger.setAttribute('aria-expanded', 'true');
        this.dialog.querySelector('[data-hn-heading]')?.focus({preventScroll:true});
      }, opts);
      this.querySelectorAll('[data-hn-close]').forEach(button => {
        button.addEventListener('click', () => this.dialog.close(), opts);
      });
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault(); this.dialog.close();
      }, opts);
      this.dialog.addEventListener('close', () => {
        unlock(this);
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.trigger.isConnected) this.trigger.focus({preventScroll:true});
      }, opts);
      this.dialog.addEventListener('pointerdown', event => {
        const r=this.dialog.getBoundingClientRect();
        this.outsidePress=event.target===this.dialog && (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom);
      }, opts);
      this.dialog.addEventListener('click', event => {
        const r=this.dialog.getBoundingClientRect();
        if (this.outsidePress && event.target===this.dialog && (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom)) this.dialog.close();
        this.outsidePress=false;
      }, opts);
      this.dialog.addEventListener('keydown', event => {
        if (event.key!=='Tab') return;
        const items=[...this.dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')].filter(el=>el.getClientRects().length && !el.closest('[inert]'));
        if (!items.length) {event.preventDefault();return;}
        const first=items[0], last=items[items.length-1], active=document.activeElement;
        if (event.shiftKey && (active===first || !items.includes(active))) {event.preventDefault();last.focus();}
        else if (!event.shiftKey && active===last) {event.preventDefault();first.focus();}
      }, opts);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      unlock(this);
      this.controller?.abort();
    }
  });
})();
